<script setup lang="ts">
const {
  orientation = 'vertical',
  source = 'search page',
  withImage = false,
} = defineProps<{
  orientation?: 'horizontal' | 'vertical'
  source?: string
  withImage?: boolean
}>()
const { t } = useI18n({ useScope: 'local' })
const { isMobile } = useBreakpoint()
</script>

<template>
  <div :class="['flex flex-col justify-center gap-4', orientation]">
    <BaseNuxtImg
      v-if="withImage"
      :alt="$t('house.scheduleACall.cta')"
      class="!size-16 rounded-full"
      src="production/assets/images/schedule-advisor.jpeg"
      sizes="128px"
    />
    <img
      v-else
      :src="`/icons/illustrations/architect-house.svg`"
      class="size-16"
    />

    <div class="schedule_text flex flex-col">
      <h2 class="m-0">
        {{ t('title') }}
      </h2>
      <p class="m-0">
        {{ t('text') }}
      </p>
    </div>

    <TheMeetingSchedulerButton
      :class="['min-w-fit bg-gray-700', { '!px-3 !py-2': isMobile }]"
      color="white"
      :source="source"
    >
      <span :class="{ 'text-sm': orientation === 'horizontal' }">
        {{ $t('search.scheduleACall') }}
      </span>
    </TheMeetingSchedulerButton>
  </div>
</template>

<style scoped>
.vertical {
  .schedule_text {
    @apply gap-4;
  }

  h2 {
    @apply text-3xl;
  }
}
.horizontal {
  @apply sm:flex-row sm:items-center;

  .schedule_text {
    @apply grow sm:gap-1;
    h2 {
      @apply text-xl;
    }
    p {
      @apply text-sm;
    }
  }
  .lc-btn--md {
    @apply sm:px-4;
  }
}
</style>

<i18n lang="json">
{
  "en": {
    "title": "Can't find the house of your dreams?",
    "text": "Our advisors are available to offer you a selection of bespoke houses."
  },
  "fr": {
    "title": "Vous ne trouvez pas la maison de vos rêves ?",
    "text": "Nos conseillers sont disponibles pour vous proposer une sélection de maisons sur-mesure."
  }
}
</i18n>
